import { DefaultLogoIcon } from "metabase/common/components/LogoIcon/LogoIcon";
import { useSelector } from "metabase/redux";
import { getApplicationName } from "metabase/selectors/whitelabel";
import { useSetting } from "metabase/settings";

/** The default of the setting `application-logo-url` on the server (`metabase.appearance.settings`). */
export const DEFAULT_LOGO_URL = "app/assets/img/logo.svg";

interface SettingsLogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

/**
 * The logo the setting `application-logo-url` names, drawn wherever the application shows its
 * logo (the top bar, the sign-in page, the about dialog); Metabase's own while the setting keeps
 * its default. The setting holds a URL the browser may load: one of this origin, or a `data:` URI.
 */
export function SettingsLogoIcon({
  height = 32,
  width,
  dark,
  fill,
}: SettingsLogoIconProps) {
  const logoUrl = useSetting("application-logo-url");
  const applicationName = useSelector(getApplicationName);

  if (!logoUrl || logoUrl === DEFAULT_LOGO_URL) {
    return (
      <DefaultLogoIcon height={height} width={width} dark={dark} fill={fill} />
    );
  }
  return (
    <img
      src={logoUrl}
      alt={applicationName}
      height={height}
      width={width}
      style={{ maxWidth: "100%" }}
      data-testid="main-logo"
    />
  );
}
